/* Auto-ported from SCRAII S-09 Workflow Designer.dc.html */

/** Display order for Step Library groups (unknown groups append after). */
export const LIBRARY_GROUPS = [
  "Data and record",
  "Communication",
  "Workflow control",
  "External integration",
  "Reporting and audit",
  "FRM action",
  "Neo",
];

export const TRIGGERS = [
  {
    "id": "schedule",
    "label": "Schedule",
    "colour": "#5F6368",
    "path": "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z M12 7v5l3 2",
    "sub": "Cadence",
    "subValue": "Every weekday at 07:00"
  },
  {
    "id": "event",
    "label": "Event",
    "colour": "#1360DF",
    "path": "M13 2 4 14h7l-1 8 9-12h-7z",
    "sub": "Event Type",
    "subValue": "Intake — Missing information identified — PT"
  },
  {
    "id": "threshold",
    "label": "Threshold",
    "colour": "#F0A730",
    "path": "M5 20V11 M12 20V4 M19 20v-6",
    "sub": "Metric",
    "subValue": "Case age exceeds 5 business days"
  },
  {
    "id": "absence",
    "label": "Absence",
    "colour": "#D11044",
    "path": "M6 18 18 6",
    "sub": "Expected event",
    "subValue": "No dispense within days supply + buffer"
  },
  {
    "id": "status",
    "label": "Status Change",
    "colour": "#1360DF",
    "path": "M4 8h13l-3-3 M20 16H7l3 3",
    "sub": "Status transition",
    "subValue": "PA: Not required → PA: Required"
  },
  {
    "id": "consent",
    "label": "Consent Change",
    "colour": "#680868",
    "path": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
    "sub": "Change",
    "subValue": "Any channel moves to revoked"
  },
  {
    "id": "inbound",
    "label": "Inbound Interaction",
    "colour": "#2FB6E8",
    "path": "M3 6h18v12H3z M3 7l9 6 9-6",
    "sub": "Direction",
    "subValue": "Patient replies on any channel"
  },
  {
    "id": "ai",
    "label": "Neo Recommendation",
    "colour": "#E4467F",
    "path": "M12 3l2.1 5.3L20 10l-5.9 1.7L12 17l-2.1-5.3L4 10l5.9-1.7z",
    "sub": "Model output",
    "subValue": "Barrier likely — confidence above 0.8"
  },
  {
    "id": "module",
    "label": "Called by Workflow",
    "colour": "#7C4DBE",
    "path": "M4 7h8l3 5 5 0M15 9l4 3-4 3",
    "sub": "Called by",
    "subValue": "Any trigger that uses the shared module, with its own settings"
  },
  {
    "id": "manual",
    "label": "Manual",
    "colour": "#5F6368",
    "path": "M8 13V5a2 2 0 0 1 4 0v6 M12 11V4a2 2 0 0 1 4 0v7 M16 11V6a2 2 0 0 1 4 0v9a6 6 0 0 1-6 6h-2a6 6 0 0 1-6-6v-3",
    "sub": "Started by",
    "subValue": "Case owner, from the case detail screen"
  }
];

export const CATALOG = {
  "condition": {
    "group": "Workflow control",
    "label": "If / Else Condition",
    "sub": "Branch on patient data or a result",
    "colour": "#F0A730",
    "path": "M6 4v6a4 4 0 0 0 4 4h8 M6 20v-6 M18 10l3 4-3 4",
    "fields": [
      {
        "key": "left",
        "label": "Attribute (days for Case age)",
        "options": [
          "Case age",
          "Barrier category",
          "Consent state",
          "Territory",
          "Latest status code",
          "Denial reason",
          "PHI consent flag",
          "On APS hold",
          "FRM contacted office before",
          "Office profiled",
          "Account tier",
          "Milestone reached"
        ]
      },
      {
        "key": "op",
        "label": "Operator",
        "options": [
          "Equal",
          "Not equal",
          "In",
          "Not In",
          "Greater than",
          "Less than"
        ]
      },
      {
        "key": "right",
        "label": "Value",
        "expr": true
      }
    ]
  },
  "branch": {
    "group": "Workflow control",
    "label": "Branch",
    "sub": "Split into multiple paths",
    "colour": "#F0A730",
    "path": "M12 4v6 M12 10 6 16v4 M12 10l6 6v4",
    "fields": [
      {
        "key": "on",
        "label": "Split on",
        "options": [
          "Case type",
          "Priority",
          "Channel",
          "Territory",
          "Denial reason",
          "Status group",
          "Account tier",
          "Pattern source"
        ]
      },
      {
        "key": "paths",
        "label": "Paths",
        "options": [
          "2 paths",
          "3 paths",
          "4 paths"
        ]
      }
    ]
  },
  "createCase": {
    "group": "Data and record",
    "label": "Create Case",
    "sub": "Create a new case",
    "colour": "#1360DF",
    "path": "M12 5v14M5 12h14",
    "fields": [
      {
        "key": "name",
        "label": "Case Name",
        "expr": true
      },
      {
        "key": "type",
        "label": "Case Type",
        "options": [
          "Prior authorisation",
          "Patient Follow Up",
          "Document chase",
          "PA appeal",
          "Copay enrolment",
          "Missing info",
          "Unable to contact",
          "New start",
          "Stalled case",
          "PA not submitted",
          "Appeal",
          "Approved not shipped",
          "Refill overdue",
          "Debrief",
          "Bridge near max",
          "Account profile",
          "Account education",
          "Account new starts",
          "Account touchpoint",
          "Account pattern"
        ]
      },
      {
        "key": "priority",
        "label": "Priority",
        "options": [
          "Low",
          "Medium",
          "High"
        ]
      },
      {
        "key": "assign",
        "label": "Assign to",
        "options": [
          "FRM",
          "Case owner",
          "Territory queue",
          "Territory FRM by physician / facility state"
        ]
      },
      {
        "key": "about",
        "label": "Case is about",
        "options": [
          "Patient",
          "Office (account case)"
        ]
      },
      {
        "key": "existing",
        "label": "If an open case exists",
        "options": [
          "Open a new case",
          "Attach to it"
        ]
      }
    ]
  },
  "updateCase": {
    "group": "Data and record",
    "label": "Update Case",
    "sub": "Set a field on the case",
    "colour": "#1360DF",
    "path": "M4 20h4l10-10-4-4L4 16z M14 6l4 4",
    "fields": [
      {
        "key": "field",
        "label": "Field",
        "options": [
          "Status",
          "Priority",
          "Owner",
          "Barrier"
        ]
      },
      {
        "key": "value",
        "label": "New value",
        "expr": true
      }
    ]
  },
  "outbound": {
    "group": "Communication",
    "label": "Outbound Communication",
    "sub": "Send via any channel - gated",
    "colour": "#7C4DBE",
    "path": "M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z",
    "gated": true,
    "fields": [
      {
        "key": "channel",
        "label": "Channel",
        "options": [
          "SMS",
          "Email",
          "Automated voice",
          "Fax",
          "Secure portal"
        ]
      },
      {
        "key": "template",
        "label": "Template",
        "options": [
          "TPL-0388 v4 · approved",
          "TPL-0402 v2 · expired"
        ]
      },
      {
        "key": "purpose",
        "label": "Purpose",
        "options": [
          "Programme updates",
          "Refill reminders",
          "Programme support"
        ]
      }
    ]
  },
  "secureLink": {
    "group": "Communication",
    "label": "Secure Document Link",
    "sub": "Share under authorization",
    "colour": "#7C4DBE",
    "path": "M9 15l6-6a4.2 4.2 0 1 1 6 6l-3 3 M15 9l-6 6a4.2 4.2 0 1 0 6 6l3-3",
    "gated": true,
    "fields": [
      {
        "key": "docType",
        "label": "Document type",
        "options": [
          "Benefit determination",
          "PA form",
          "Appeal submission"
        ]
      },
      {
        "key": "recipient",
        "label": "Recipient",
        "options": [
          "Prescriber practice",
          "Specialty pharmacy",
          "Hub"
        ]
      }
    ]
  },
  "emailAlert": {
    "group": "Reporting and audit",
    "label": "Email Alert",
    "sub": "Notify a colleague by email",
    "colour": "#E4467F",
    "path": "M3 6h18v12H3z M3 7l9 6 9-6",
    "fields": [
      {
        "key": "to",
        "label": "Recipient",
        "options": [
          "Case owner",
          "Territory manager",
          "Consent admin",
          "FRM leadership"
        ]
      },
      {
        "key": "subject",
        "label": "Subject",
        "expr": true
      }
    ]
  },
  "smsAlert": {
    "group": "Reporting and audit",
    "label": "SMS Alert",
    "sub": "Notify a colleague by text",
    "colour": "#E4467F",
    "path": "M4 5h16v11H9l-5 4z",
    "fields": [
      {
        "key": "to",
        "label": "Recipient",
        "options": [
          "Case owner",
          "Territory manager"
        ]
      },
      {
        "key": "body",
        "label": "Message",
        "expr": true
      }
    ]
  },
  "wait": {
    "group": "Workflow control",
    "label": "Wait / Delay",
    "sub": "Pause for minutes or days, or for the days the previous step recorded",
    "colour": "#22B36B",
    "path": "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z M12 7v5l3 2",
    "fields": [
      {
        "key": "delay",
        "label": "Delay",
        "allowCustom": true,
        "options": [
          "Days from the previous step",
          "5 minutes",
          "10 minutes",
          "1 business day",
          "2 business days",
          "5 business days",
          "14 days"
        ]
      },
      {
        "key": "from",
        "label": "Count from",
        "optional": true,
        "options": [
          "Since the last step",
          "From the start of the workflow"
        ]
      },
      {
        "key": "stop",
        "label": "Stop condition",
        "options": [
          "None",
          "A dispense arrives",
          "Case is closed",
          "PA status is Approved or Denied"
        ]
      }
    ]
  },
  "stop": {
    "group": "Workflow control",
    "label": "Stop Workflow",
    "sub": "Terminate early if a rule holds",
    "colour": "#22B36B",
    "path": "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z M8 12h8",
    "fields": [
      {
        "key": "when",
        "label": "Exit when",
        "options": [
          "Case is closed",
          "Consent is revoked",
          "A dispense arrives",
          "PA status is Approved or Denied"
        ]
      }
    ]
  },
  "moveCaseStage": {
    "group": "Workflow control",
    "label": "Move to case stage",
    "sub": "Set the case to a stage from its case flow",
    "colour": "#22B36B",
    "path": "M4 12h12M12 6l6 6-6 6",
    "fields": [
      {
        "key": "stage",
        "label": "Stage"
      }
    ]
  },
  "end": {
    "group": "Workflow control",
    "label": "End",
    "sub": "Record an explicit outcome",
    "colour": "#5F6368",
    "path": "M5 5h14v14H5z",
    "fields": [
      {
        "key": "status",
        "label": "End Status",
        "options": [
          "Success",
          "Cancelled",
          "Failed"
        ]
      },
      {
        "key": "log",
        "label": "Log Message",
        "expr": true
      }
    ]
  },
  "moveStage": {
    "group": "Data and record",
    "label": "Move Case Stage",
    "sub": "Advance the case in its lifecycle",
    "colour": "#1360DF",
    "path": "M4 6v12 M7 12h9 M13 8l4 4-4 4 M20 6v12",
    "stageStep": true,
    "fields": [
      {
        "key": "stage",
        "label": "Moves case to",
        "options": [
          "Case opened",
          "Documentation gathered",
          "Submission outstanding",
          "Determination",
          "Closed"
        ]
      },
      {
        "key": "guard",
        "label": "If the move is not a legal transition",
        "options": [
          "Block and flag for review",
          "Skip this step",
          "Fail the workflow"
        ]
      }
    ]
  },
  "updatePatientStatus": {
    "group": "Data and record",
    "label": "Update Patient Status",
    "sub": "Move the patient stage in Oracle",
    "colour": "#1360DF",
    "path": "M4 12h6l2-5 3 10 2-5h3",
    "fields": [
      {
        "key": "field",
        "label": "Status held in",
        "options": [
          "FRM status",
          "DU status",
          "Programme stage"
        ]
      },
      {
        "key": "value",
        "label": "New status",
        "options": [
          "Enrolled",
          "Benefit verification",
          "PA pending",
          "PA approved",
          "On therapy",
          "Discontinued"
        ]
      }
    ]
  },
  "updatePatientField": {
    "group": "Data and record",
    "label": "Update Patient Field",
    "sub": "Write one field back to the database",
    "colour": "#1360DF",
    "path": "M5 4h9l5 5v11H5zM14 4v5h5",
    "fields": [
      {
        "key": "field",
        "label": "Target field",
        "options": [
          "frm_status",
          "frm_owner",
          "du_status",
          "referral_source",
          "consent_flag"
        ]
      },
      {
        "key": "value",
        "label": "Value",
        "expr": true
      },
      {
        "key": "overwrite",
        "label": "If already set",
        "options": [
          "Overwrite",
          "Leave as is"
        ]
      }
    ]
  },
  "createNote": {
    "group": "Data and record",
    "label": "Create a Note",
    "sub": "Log a system note on the record",
    "colour": "#1360DF",
    "path": "M5 4h14v16H5zM8 9h8M8 13h8M8 17h5",
    "fields": [
      {
        "key": "scope",
        "label": "Attach to",
        "options": [
          "Patient record",
          "Case",
          "Prescriber"
        ]
      },
      {
        "key": "body",
        "label": "Note text",
        "expr": true
      },
      {
        "key": "audience",
        "label": "Visible to",
        "options": [
          "FRM only",
          "FRM and manager",
          "Everyone on the programme"
        ]
      }
    ]
  },
  "closeTask": {
    "group": "Data and record",
    "label": "Close / Complete a Task",
    "sub": "Auto-close an open task",
    "colour": "#1360DF",
    "path": "M4 13l5 5L20 7",
    "fields": [
      {
        "key": "task",
        "label": "Task",
        "options": [
          "Any open task on this case",
          "Benefit verification",
          "PA follow up",
          "Document chase"
        ]
      },
      {
        "key": "when",
        "label": "Close when",
        "options": [
          "The condition is met",
          "The case is closed",
          "A dispense arrives"
        ]
      }
    ]
  },
  "scheduleCall": {
    "group": "Communication",
    "label": "Schedule a Call",
    "sub": "Book an outbound call on a calendar",
    "colour": "#7C4DBE",
    "path": "M5 4h4l2 5-3 2a10 10 0 0 0 5 5l2-3 5 2v4h-3A13 13 0 0 1 4 7z",
    "fields": [
      {
        "key": "owner",
        "label": "Calendar",
        "options": [
          "FRM on the case",
          "Territory queue",
          "Hub liaison"
        ]
      },
      {
        "key": "when",
        "label": "Schedule for",
        "options": [
          "Same business day",
          "Next business day",
          "Two business days"
        ]
      },
      {
        "key": "purpose",
        "label": "Call purpose",
        "options": [
          "Enrolment follow up",
          "Adherence check",
          "Barrier resolution"
        ]
      }
    ]
  },
  "sendEmail": {
    "group": "Communication",
    "label": "Send Email",
    "sub": "Email a patient, HCP or care team",
    "colour": "#7C4DBE",
    "path": "M3 6h18v12H3zM3 7l9 6 9-6",
    "gated": true,
    "fields": [
      {
        "key": "to",
        "label": "Recipient",
        "options": [
          "Patient",
          "HCP office",
          "Care team"
        ]
      },
      {
        "key": "template",
        "label": "Template",
        "options": [
          "TPL-0388 v4 · approved",
          "TPL-0402 v2 · expired"
        ]
      },
      {
        "key": "purpose",
        "label": "Purpose",
        "options": [
          "Programme updates",
          "Refill reminders",
          "Programme support"
        ]
      }
    ]
  },
  "sendSms": {
    "group": "Communication",
    "label": "Send SMS / Text",
    "sub": "Text a patient where consent allows",
    "colour": "#7C4DBE",
    "path": "M4 5h16v11H9l-5 4z",
    "gated": true,
    "fields": [
      {
        "key": "to",
        "label": "Recipient",
        "options": [
          "Patient",
          "HCP office"
        ]
      },
      {
        "key": "template",
        "label": "Template",
        "options": [
          "TPL-0388 v4 · approved",
          "TPL-0402 v2 · expired"
        ]
      }
    ]
  },
  "sendFax": {
    "group": "Communication",
    "label": "Send Fax",
    "sub": "Fax documents to a payer or office",
    "colour": "#7C4DBE",
    "path": "M7 8V4h10v4M5 8h14v8h-3v4H8v-4H5zM9 12h6",
    "gated": true,
    "fields": [
      {
        "key": "to",
        "label": "Recipient",
        "options": [
          "Payer",
          "HCP office",
          "Specialty pharmacy"
        ]
      },
      {
        "key": "doc",
        "label": "Document",
        "options": [
          "Clinical notes",
          "PA form",
          "Benefit summary",
          "Appeal packet"
        ]
      }
    ]
  },
  "eSign": {
    "group": "Communication",
    "label": "Send eSign Request",
    "sub": "Send a document for signature",
    "colour": "#7C4DBE",
    "path": "M4 18c4-1 5-9 8-9s3 5 8 4M4 21h16",
    "gated": true,
    "fields": [
      {
        "key": "doc",
        "label": "Document",
        "options": [
          "Patient consent",
          "Authorisation to disclose",
          "Enrolment form"
        ]
      },
      {
        "key": "signer",
        "label": "Signer",
        "options": [
          "Patient",
          "Prescriber",
          "Both in order"
        ]
      },
      {
        "key": "expiry",
        "label": "Expires after",
        "options": [
          "3 days",
          "7 days",
          "14 days"
        ]
      }
    ]
  },
  "loop": {
    "group": "Workflow control",
    "label": "Loop",
    "sub": "Repeat a step until a rule holds",
    "colour": "#22B36B",
    "path": "M4 9a8 8 0 0 1 14-3M20 15a8 8 0 0 1-14 3M18 3v4h-4M6 21v-4h4",
    "fields": [
      {
        "key": "mode",
        "label": "Repeat",
        "options": [
          "A fixed number of times",
          "Until a condition is met"
        ]
      },
      {
        "key": "limit",
        "label": "Maximum passes",
        "options": [
          "3",
          "5",
          "10"
        ]
      },
      {
        "key": "gap",
        "label": "Gap between passes",
        "options": [
          "1 business day",
          "3 business days",
          "7 days"
        ]
      }
    ]
  },
  "triggerWorkflow": {
    "group": "Workflow control",
    "label": "Trigger Another Workflow",
    "sub": "Chain a second workflow",
    "colour": "#22B36B",
    "path": "M4 7h8l3 5 5 0M15 9l4 3-4 3",
    "fields": [
      {
        "key": "target",
        "label": "Workflow",
        "options": [
          "Therapy initiation",
          "Refill adherence",
          "Reverification",
          "Copay enrolment",
          "Office outreach module",
          "Debrief (G)",
          "Unable to contact (UC)",
          "Access education (AW2)"
        ]
      },
      {
        "key": "pass",
        "label": "Carry over",
        "options": [
          "Patient and case",
          "Patient only"
        ]
      },
      {
        "key": "mode",
        "label": "This workflow",
        "options": [
          "Continues",
          "Stops once fired"
        ]
      }
    ]
  },
  "callApi": {
    "group": "External integration",
    "label": "Call External API",
    "sub": "POST or GET to a third-party system",
    "colour": "#0FA5A5",
    "path": "M8 6 3 12l5 6M16 6l5 6-5 6M13 4l-2 16",
    "fields": [
      {
        "key": "method",
        "label": "Method",
        "options": [
          "POST",
          "GET"
        ]
      },
      {
        "key": "endpoint",
        "label": "Endpoint",
        "expr": true
      },
      {
        "key": "onFail",
        "label": "If it fails",
        "options": [
          "Retry three times",
          "Flag for review",
          "Stop the workflow"
        ]
      }
    ]
  },
  "sendToHub": {
    "group": "External integration",
    "label": "Send to HUB",
    "sub": "Push patient data to Hub Services",
    "colour": "#0FA5A5",
    "path": "M12 3 3 8l9 5 9-5-9-5ZM3 14l9 5 9-5",
    "fields": [
      {
        "key": "feed",
        "label": "Feed",
        "options": [
          "Hub intake",
          "Hub status",
          "Hub reconciliation",
          "Hub PAP check"
        ]
      },
      {
        "key": "payload",
        "label": "Payload",
        "options": [
          "Full case",
          "Status change only",
          "Consent state"
        ]
      }
    ]
  },
  "notifySp": {
    "group": "External integration",
    "label": "Notify Specialty Pharmacy",
    "sub": "Send an Rx or shipment instruction",
    "colour": "#0FA5A5",
    "path": "M3 8h13v9H3zM16 11h3l2 3v3h-5M6 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M18 20a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    "fields": [
      {
        "key": "sp",
        "label": "Pharmacy",
        "options": [
          "Assigned SP",
          "SP of record",
          "Named SP"
        ]
      },
      {
        "key": "instruction",
        "label": "Instruction",
        "options": [
          "New Rx",
          "Shipment hold",
          "Shipment release",
          "Address change"
        ]
      }
    ]
  },
  "payerSubmit": {
    "group": "External integration",
    "label": "Payer Portal Submit",
    "sub": "Submit a PA or BV request",
    "colour": "#0FA5A5",
    "path": "M5 21V9l7-5 7 5v12M9 21v-6h6v6",
    "fields": [
      {
        "key": "request",
        "label": "Request",
        "options": [
          "Prior authorisation",
          "Benefit verification",
          "Appeal"
        ]
      },
      {
        "key": "portal",
        "label": "Route via",
        "options": [
          "Payer portal",
          "Clearing house"
        ]
      },
      {
        "key": "attach",
        "label": "Attach",
        "options": [
          "Clinical notes",
          "Clinical notes and PA form",
          "Nothing"
        ]
      }
    ]
  },
  "auditLog": {
    "group": "Reporting and audit",
    "label": "Log to Audit Trail",
    "sub": "Write an immutable audit entry",
    "colour": "#093868",
    "path": "M6 3h9l4 4v14H6zM9 12h7M9 16h7",
    "fields": [
      {
        "key": "event",
        "label": "Event label",
        "expr": true
      },
      {
        "key": "detail",
        "label": "Record",
        "options": [
          "Actor and timestamp",
          "Actor, timestamp and field diff"
        ]
      }
    ]
  },
  "updateKpi": {
    "group": "Reporting and audit",
    "label": "Update KPI / Metric",
    "sub": "Move a programme counter",
    "colour": "#093868",
    "path": "M4 20V10M10 20V4M16 20v-7M22 20H2",
    "fields": [
      {
        "key": "metric",
        "label": "Metric",
        "options": [
          "Time to therapy start",
          "Time to first touch",
          "PA turnaround",
          "Office blocker count",
          "Payer denial count"
        ]
      },
      {
        "key": "op",
        "label": "Operation",
        "options": [
          "Increment",
          "Set",
          "Stop the clock"
        ]
      }
    ]
  },
  "generateReport": {
    "group": "Reporting and audit",
    "label": "Generate Report",
    "sub": "Take a report snapshot",
    "colour": "#093868",
    "path": "M5 4h9l5 5v11H5zM9 13h6M9 17h4",
    "fields": [
      {
        "key": "report",
        "label": "Report",
        "options": [
          "Patient snapshot",
          "Programme summary",
          "Case audit",
          "Open case ageing"
        ]
      },
      {
        "key": "delivery",
        "label": "Delivery",
        "options": [
          "Store on the record",
          "Email to the case owner"
        ]
      }
    ]
  },
  "flagReview": {
    "group": "Reporting and audit",
    "label": "Flag for Review",
    "sub": "Mark the patient for a manual look",
    "colour": "#093868",
    "path": "M6 21V4h11l-2 4 2 4H6",
    "fields": [
      {
        "key": "reason",
        "label": "Reason",
        "expr": true
      },
      {
        "key": "who",
        "label": "Route to",
        "options": [
          "FRM on the case",
          "Territory manager",
          "Hub liaison",
          "FRM leadership",
          "Market access"
        ]
      },
      {
        "key": "sla",
        "label": "Review within",
        "options": [
          "1 business day",
          "3 business days"
        ]
      }
    ]
  },
  "frmAction": {
    "group": "FRM action",
    "label": "FRM Action + Confirm",
    "sub": "FRM reviews the email and chooses Send: Yes or No",
    "colour": "#C5841B",
    "path": "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    "fields": [
      {
        "key": "show",
        "label": "Present to the FRM",
        "options": [
          "Email from the previous Draft Office Email step"
        ]
      },
      {
        "key": "ask",
        "label": "Ask the FRM",
        "options": [
          "Send this email? Yes / No"
        ]
      },
      {
        "key": "onYes",
        "label": "If Yes",
        "options": [
          "Send the email and log it on the case"
        ]
      },
      {
        "key": "onNo",
        "label": "If No",
        "options": [
          "Do not send, log it, and continue",
          "Do not send and end the workflow"
        ]
      },
      {
        "key": "days",
        "label": "Days",
        "multi": true,
        "optional": true,
        "options": [
          "Day 1",
          "Day 3",
          "Day 5"
        ]
      }
    ]
  },
  "frmDecision": {
    "group": "FRM action",
    "label": "FRM Decision",
    "sub": "FRM escalates the case, or enters the days to wait before the next step",
    "colour": "#C5841B",
    "path": "M12 3v10M8 9l4 4 4-4M6 21h4M14 21h4",
    "fields": [
      {
        "key": "ask",
        "label": "Ask the FRM"
      },
      {
        "key": "unit",
        "label": "Wait is counted in",
        "options": [
          "Business days",
          "Days"
        ]
      },
      {
        "key": "maxDays",
        "label": "Longest wait the FRM can enter",
        "optional": true
      }
    ]
  },
  "assignCase": {
    "group": "FRM action",
    "label": "Assign Case",
    "sub": "Assign the case to FRM leadership or another leadership team",
    "colour": "#C5841B",
    "path": "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
    "fields": [
      {
        "key": "team",
        "label": "Assign the case to",
        "options": [
          "FRM leadership",
          "Territory leadership",
          "Hub leadership",
          "Market access leadership",
          "Patient support leadership",
          "Another leadership team"
        ]
      },
      {
        "key": "teamName",
        "label": "Leadership team",
        "optional": true
      },
      {
        "key": "note",
        "label": "Note on the case",
        "optional": true
      }
    ]
  },
  "buildBrief": {
    "group": "Data and record",
    "label": "Build Brief",
    "sub": "Fill the FRM brief from case data, no AI",
    "colour": "#1360DF",
    "path": "M5 4h14v16H5zM8 8h8M8 12h8M8 16h4",
    "fields": [
      {
        "key": "content",
        "label": "Brief shows",
        "options": [
          "Patient ID or name per PHI consent · status in plain words · days in status · SP/hub contact · other open cases at this office",
          "Prescriber, facility, academic / loopback flag, SPs used, payer mix"
        ]
      },
      {
        "key": "show",
        "label": "Shown on",
        "options": [
          "MyDay and case detail",
          "Case detail"
        ]
      }
    ]
  },
  "officeBatch": {
    "group": "Communication",
    "label": "Office Batch Check",
    "sub": "One FRM outreach per office per window",
    "colour": "#7C4DBE",
    "path": "M3 21h18M5 21V8l7-4 7 4v13M9 21v-6h6v6",
    "fields": [
      {
        "key": "window",
        "label": "Window",
        "options": [
          "1 business day",
          "2 business days",
          "5 business days"
        ]
      },
      {
        "key": "ifOpen",
        "label": "If an outreach to this office is open",
        "options": [
          "Add this case to the open outreach",
          "Start a new outreach"
        ]
      }
    ]
  },
  "draftEmail": {
    "group": "Communication",
    "label": "Draft Office Email",
    "sub": "Template draft for the FRM to review",
    "colour": "#7C4DBE",
    "path": "M3 6h18v12H3z M3 7l9 6 9-6 M15 15l5 5",
    "gated": true,
    "gates": ["Approved template"],
    "fields": [
      {
        "key": "tpl",
        "label": "Email template",
        "briefTpl": true
      },
      {
        "key": "to",
        "label": "To",
        "options": [
          "Office contact from account profile",
          "FRM only (talking points)"
        ]
      },
      {
        "key": "cc",
        "label": "Cc",
        "options": [
          "SP / hub contact on the case",
          "None"
        ]
      },
      {
        "key": "ai",
        "label": "Drafting",
        "options": [
          "Template only",
          "AI-personalised · paid AI tier"
        ]
      }
    ]
  },
  "waitMilestone": {
    "group": "Workflow control",
    "label": "Wait for Milestone",
    "sub": "Wait for a milestone code or time out",
    "colour": "#22B36B",
    "path": "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z M12 7v5l3 2 M17 3l4 4",
    "fields": [
      {
        "key": "milestones",
        "label": "Milestone codes",
        "options": [
          "Exit codes passed in by the trigger",
          "PH04 · PH05 · PS05 (enrollment / BI)",
          "PH12 · PS13 · PS16 (PA submitted or decided)",
          "PS34 · AS01 (scheduled or shipped)",
          "New dispense",
          "Any milestone advance"
        ]
      },
      {
        "key": "timeout",
        "label": "Time out after",
        "options": [
          "Days passed in by the trigger",
          "1 business day",
          "2 business days",
          "3 business days",
          "5 business days",
          "14 days"
        ]
      },
      {
        "key": "ignore",
        "label": "Do not treat as progress",
        "options": [
          "Attempt codes PH02.x / PH03.x"
        ]
      },
      {
        "key": "onMilestone",
        "label": "When a milestone arrives",
        "options": [
          "Close case with reason",
          "Continue to the next step"
        ]
      },
      {
        "key": "onTimeout",
        "label": "When it times out",
        "options": [
          "Next attempt",
          "Escalate",
          "Continue to the next step"
        ]
      }
    ]
  },
  "attempt": {
    "group": "Workflow control",
    "label": "Attempt",
    "sub": "Named outreach attempt that sends a template",
    "colour": "#1360DF",
    "path": "M4 9a8 8 0 0 1 14-3M20 15a8 8 0 0 1-14 3M18 3v4h-4M6 21v-4h4 M10 12h4",
    "fields": [
      {
        "key": "name",
        "label": "Attempt name"
      },
      {
        "key": "runsAfter",
        "label": "When it runs",
        "options": [
          "Right away",
          "After 1 day",
          "After 2 days",
          "After 3 days"
        ]
      },
      {
        "key": "template",
        "label": "Template"
      },
      {
        "key": "to",
        "label": "To",
        "multi": true
      },
      {
        "key": "cc",
        "label": "Cc",
        "multi": true,
        "optional": true
      }
    ]
  },
  "attemptSchedule": {
    "group": "Workflow control",
    "label": "Attempt Schedule",
    "sub": "Next attempt with the next script",
    "colour": "#22B36B",
    "path": "M4 9a8 8 0 0 1 14-3M20 15a8 8 0 0 1-14 3M18 3v4h-4M6 21v-4h4 M10 12h4",
    "fields": [
      {
        "key": "schedule",
        "label": "Attempt days",
        "options": [
          "Schedule passed in by the trigger",
          "Day 1 · 3 · 5",
          "Day T · 2T (stage threshold)",
          "Day 1 · 4 · 10, then every 14",
          "Single attempt"
        ]
      },
      {
        "key": "scripts",
        "label": "Script per attempt",
        "options": [
          "Scripts passed in by the trigger",
          "A → B → Day 5 call brief",
          "Status check ×2",
          "Same script each time"
        ]
      },
      {
        "key": "max",
        "label": "Maximum attempts",
        "options": [
          "1",
          "2",
          "3",
          "Until an exit code"
        ]
      },
      {
        "key": "onMax",
        "label": "After the last attempt",
        "options": [
          "Escalate to FRM leadership",
          "Stay open, no escalation"
        ]
      }
    ]
  },
  "outreachModule": {
    "group": "Workflow control",
    "label": "Office Outreach Module",
    "sub": "Shared: brief, batch, draft, FRM action, wait, retry",
    "colour": "#1360DF",
    "path": "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 16h7M16.5 13v7",
    "fields": []
  },
  "aiSummarise": {
    "group": "Neo",
    "label": "Neo Summarize Patient",
    "sub": "Summarise the record at this point",
    "colour": "#680868",
    "future": true,
    "path": "M12 3l2 5 5 2-5 2-2 5-2-5-5-2 5-2zM19 17l1 2 2 1-2 1-1 2-1-2-2-1 2-1z",
    "fields": [
      {
        "key": "scope",
        "label": "Scope",
        "options": [
          "Whole record",
          "Since the last touch",
          "This case only"
        ]
      },
      {
        "key": "place",
        "label": "Write to",
        "options": [
          "Case note",
          "Manager view only"
        ]
      }
    ]
  },
  "aiRisk": {
    "group": "Neo",
    "label": "Neo Risk Score",
    "sub": "Score the patient and write the result",
    "colour": "#680868",
    "future": true,
    "path": "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 12l4-3",
    "fields": [
      {
        "key": "model",
        "label": "Model",
        "options": [
          "Discontinuation risk",
          "PA denial risk",
          "Adherence risk"
        ]
      },
      {
        "key": "place",
        "label": "Write to",
        "options": [
          "Patient record field",
          "Flag only"
        ]
      }
    ]
  },
  "aiNext": {
    "group": "Neo",
    "label": "Neo Recommend Next Action",
    "sub": "Surface the recommended next step",
    "colour": "#680868",
    "future": true,
    "path": "M4 17l5-5 4 3 6-7M17 8h3v3",
    "fields": [
      {
        "key": "basis",
        "label": "Basis",
        "options": [
          "Patient data",
          "Patient data and programme history"
        ]
      },
      {
        "key": "place",
        "label": "Surface in",
        "options": [
          "Case detail",
          "Case board card"
        ]
      }
    ]
  }
};

export const RZ_STYLE = {
  "rz-mi": {
    "code": "MI",
    "group": "patient",
    "codes": [
      "PH02.7",
      "PH03.1",
      "PS02",
      "PS11",
      "PS25"
    ],
    "hub": "Outreach to office and patient by phone, fax and letter; codes each attempt (cadence TBC).",
    "module": {
      "wait": 2,
      "escalate": true,
      "every": 0,
      "optional": false,
      "attempts": [
        {
          "day": "1",
          "tpl": "A — day 1, intro and ask",
          "channel": "Email or call",
          "hub": "PH02.7 · PH03.1 · PS02",
          "ask": "Tells patient to call hub / SP"
        },
        {
          "day": "3",
          "tpl": "B — day 3, follow-up",
          "channel": "Email or call",
          "hub": "PH02.8 · PH03.2",
          "ask": "Sends info to the hub, not FRM"
        },
        {
          "day": "5",
          "tpl": "Day 5 call brief",
          "channel": "Call or visit",
          "hub": "PH02.9 · PH03.3",
          "ask": "Updates contact: phone or caregiver"
        }
      ]
    },
    "progress": [
      "PH04",
      "PH05",
      "PS05"
    ],
    "exhausted": [
      "PH02",
      "PH03",
      "CH04",
      "CS04",
      "CS06"
    ],
    "onExhausted": "Escalate to FRM leadership; open debrief (trigger G)",
    "cancelTo": "G",
    "early": [],
    "threshold": "On receipt (next 8 AM feed)",
    "feed": "Status · daily 8 AM ET",
    "priority": "High",
    "caseType": "Missing info",
    "guardrails": [
      "Missing items always go to the hub or SP, never to the FRM",
      "Name the patient only when PATIENT_PHI_CONSENT_FLAG = Y; otherwise use the case ID",
      "No PHI in email subject lines or push notifications"
    ],
    "openItems": [
      "We know that information is missing and the attempt number, not what is missing. Ask AssistRx for the missing-item list."
    ]
  },
  "rz-uc": {
    "code": "UC",
    "group": "patient",
    "codes": [
      "PS29",
      "APS29",
      "PS30",
      "APS30"
    ],
    "hub": "SP keeps calling the patient (PS29) or HCP (PS30).",
    "module": {
      "wait": 2,
      "escalate": true,
      "every": 0,
      "optional": false,
      "attempts": [
        {
          "day": "1",
          "tpl": "A — day 1, intro and ask",
          "channel": "Email or call",
          "hub": "PS29 · PS30",
          "ask": "Tells patient to call SP"
        },
        {
          "day": "3",
          "tpl": "B — day 3, follow-up",
          "channel": "Email or call",
          "hub": "APS29 · APS30",
          "ask": "Better number or caregiver"
        },
        {
          "day": "5",
          "tpl": "Day 5 call brief",
          "channel": "Call or visit",
          "hub": "Final attempt",
          "ask": "Updates contact"
        }
      ]
    },
    "progress": [
      "PH04",
      "PH05",
      "PS05"
    ],
    "exhausted": [
      "CS04",
      "DS04",
      "CS06",
      "DS06",
      "CH04",
      "BH31",
      "BH32"
    ],
    "onExhausted": "Escalate to FRM leadership; open debrief (trigger G)",
    "cancelTo": "G",
    "early": [],
    "threshold": "On receipt (next 8 AM feed)",
    "feed": "Status · daily 8 AM ET",
    "priority": "High",
    "caseType": "Unable to contact",
    "guardrails": [
      "Name the patient only when PATIENT_PHI_CONSENT_FLAG = Y",
      "No PHI in email subject lines or push notifications"
    ],
    "openItems": []
  },
  "rz-a": {
    "code": "A",
    "group": "patient",
    "codes": [
      "NEW_PATIENT_START = Y",
      "NEW_NPI"
    ],
    "hub": "Enrollment and BI.",
    "module": null,
    "progress": [
      "Intro sent",
      "First fill"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "G",
    "early": [
      "Office already known: skip the intro"
    ],
    "threshold": "On receipt",
    "feed": "Status, Patient View, HCP · daily",
    "priority": "Medium",
    "caseType": "New start",
    "guardrails": [
      "Need a \"first seen\" date per NPI to detect a new prescriber"
    ],
    "openItems": [
      "HCP extract needs a first-seen date per NPI"
    ]
  },
  "rz-b": {
    "code": "B",
    "group": "patient",
    "codes": [
      "LAST_STATUS_DATE",
      "HUB_LAST_STATUS_DATE",
      "COM_SP_LAST_STATUS_DATE"
    ],
    "hub": "Hub and SP continue their own work.",
    "module": {
      "wait": 3,
      "escalate": true,
      "every": 0,
      "optional": false,
      "attempts": [
        {
          "day": "T",
          "tpl": "Status check (stalled case)",
          "channel": "Email or phone",
          "hub": "",
          "ask": "Explains the hold-up"
        },
        {
          "day": "2T",
          "tpl": "Status check (stalled case)",
          "channel": "Email or phone",
          "hub": "",
          "ask": "Explains the hold-up"
        }
      ]
    },
    "progress": [
      "Any milestone advance"
    ],
    "exhausted": [],
    "onExhausted": "Repeat once at 2× the threshold; then escalate to FRM leadership",
    "cancelTo": "G",
    "early": [
      "Reason already visible (e.g. PS29): switch to that situation (UC)"
    ],
    "threshold": "Older than the stage threshold",
    "feed": "Patient View · daily",
    "priority": "Medium",
    "caseType": "Stalled case",
    "guardrails": [
      "A new attempt number alone does not count as progress"
    ],
    "openItems": [
      "PA / appeal threshold waits on the turnaround benchmark"
    ]
  },
  "rz-c": {
    "code": "C",
    "group": "patient",
    "codes": [
      "PS11",
      "PH11"
    ],
    "hub": "Sends the PA form or CMM key and reminds the office.",
    "module": {
      "wait": 3,
      "escalate": true,
      "every": 0,
      "optional": false,
      "attempts": [
        {
          "day": "5",
          "tpl": "PA reminder",
          "channel": "Email or phone",
          "hub": "PH11 · PS11",
          "ask": "Submits PA to payer"
        }
      ]
    },
    "progress": [
      "PH12",
      "PS13",
      "PS16"
    ],
    "exhausted": [],
    "onExhausted": "Escalate to FRM leadership",
    "cancelTo": "G",
    "early": [],
    "threshold": "No PH12 after 5 business days",
    "feed": "Status · daily",
    "priority": "High",
    "caseType": "PA not submitted",
    "guardrails": [
      "cc the SP contact on the reminder"
    ],
    "openItems": []
  },
  "rz-d": {
    "code": "D",
    "group": "patient",
    "codes": [
      "PS16",
      "PH14",
      "PH16",
      "PH170",
      "PH171",
      "PH172",
      "PH173"
    ],
    "hub": "Tells the office an appeal is needed.",
    "module": {
      "wait": 14,
      "escalate": false,
      "every": 14,
      "optional": false,
      "attempts": [
        {
          "day": "1",
          "tpl": "Appeal support",
          "channel": "Email or phone",
          "hub": "PH14–PH173 · PS16",
          "ask": "Prepares appeal"
        },
        {
          "day": "4",
          "tpl": "Appeal support",
          "channel": "Follow-up",
          "hub": "PH21 · PH22 · PS17",
          "ask": "Appeal in progress"
        },
        {
          "day": "10",
          "tpl": "Appeal support",
          "channel": "Follow-up",
          "hub": "PH21 · PH22 · PS17",
          "ask": "Appeal in progress"
        }
      ]
    },
    "progress": [
      "PH23",
      "PS23"
    ],
    "exhausted": [
      "PH180",
      "PH187"
    ],
    "onExhausted": "Route to PAP check; log the reason",
    "cancelTo": "G",
    "early": [
      "Denial is off-label: log only and end"
    ],
    "threshold": "On receipt",
    "feed": "Status · daily",
    "priority": "High",
    "caseType": "Appeal",
    "guardrails": [
      "Follow-ups on day 4, day 10, then every 14 days while PH21 / PH22 / PS17 is open"
    ],
    "openItems": [
      "SP denials (PS16) carry no reason; get it from the SP"
    ]
  },
  "rz-e": {
    "code": "E",
    "group": "patient",
    "codes": [
      "PS13",
      "PH13",
      "PS27"
    ],
    "hub": "SP schedules shipment with the patient.",
    "module": {
      "wait": 3,
      "escalate": true,
      "every": 0,
      "optional": false,
      "attempts": [
        {
          "day": "4",
          "tpl": "Ask office to have patient call SP",
          "channel": "Email or phone",
          "hub": "PS13 · PH13 · PS27",
          "ask": "Asks patient to call SP"
        }
      ]
    },
    "progress": [
      "PS34",
      "AS01"
    ],
    "exhausted": [],
    "onExhausted": "Escalate to FRM leadership",
    "cancelTo": "G",
    "early": [],
    "threshold": "No PS34 or AS01 after 4 days",
    "feed": "Status · daily",
    "priority": "Medium",
    "caseType": "Approved not shipped",
    "guardrails": [
      "Use status codes, not fill dates, for this trigger"
    ],
    "openItems": []
  },
  "rz-f": {
    "code": "F",
    "group": "patient",
    "codes": [
      "COM_SP_LAST_FILL_DATE",
      "COM_SP_LAST_FILL_DAYS_SUP"
    ],
    "hub": "Refill reminder calls.",
    "module": {
      "wait": 5,
      "escalate": true,
      "every": 0,
      "optional": false,
      "attempts": [
        {
          "day": "1",
          "tpl": "Refill check",
          "channel": "Email or phone",
          "hub": "",
          "ask": "Confirms therapy status"
        }
      ]
    },
    "progress": [
      "New dispense"
    ],
    "exhausted": [],
    "onExhausted": "Escalate to FRM leadership",
    "cancelTo": "G",
    "early": [
      "Patient on an APS hold (APS35, APS67, APS68, APS42): no alert"
    ],
    "threshold": "Last fill + days supply + 10 days, no new dispense",
    "feed": "Dispense · weekly Tuesday",
    "priority": "Medium",
    "caseType": "Refill overdue",
    "guardrails": [
      "Dispense data arrives weekly on Tuesday; this trigger can lag up to a week"
    ],
    "openItems": [
      "Ask SPs for daily dispense, or accept the weekly lag"
    ]
  },
  "rz-g": {
    "code": "G",
    "group": "patient",
    "codes": [
      "CS*",
      "DS*"
    ],
    "hub": "",
    "module": null,
    "progress": [
      "Debrief captured"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "",
    "early": [
      "Transfer (CS07, CS10, DS07, DS10): FYI only, ends at once"
    ],
    "threshold": "On receipt",
    "feed": "Status · daily",
    "priority": "Low",
    "caseType": "Debrief",
    "guardrails": [
      "Replaces Jeanne's weekly manual search by latest status"
    ],
    "openItems": []
  },
  "rz-h": {
    "code": "H",
    "group": "patient",
    "codes": [
      "QS_APPROVED_DT",
      "BRIDGE_REF_START_DATE"
    ],
    "hub": "Works coverage (insurance vs PAP).",
    "module": {
      "wait": 5,
      "escalate": false,
      "every": 0,
      "optional": true,
      "attempts": [
        {
          "day": "1",
          "tpl": "Coverage progress (bridge / QS)",
          "channel": "Optional email or phone",
          "hub": "",
          "ask": "Sends anything outstanding"
        }
      ]
    },
    "progress": [
      "First fill",
      "PAP",
      "Extension"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "G",
    "early": [],
    "threshold": "Program max − N days, no commercial first fill",
    "feed": "Patient View · daily",
    "priority": "Low",
    "caseType": "Bridge near max",
    "guardrails": [
      "Outreach is optional"
    ],
    "openItems": [
      "Program max duration and lead time come from Sanofi; not in the data dictionary"
    ]
  },
  "rz-aw1": {
    "code": "AW1",
    "group": "account",
    "codes": [
      "NEW_NPI",
      "FACILITY_ID",
      "NEW_PATIENT_START = Y",
      "PRIORITY_LIST"
    ],
    "hub": "",
    "module": null,
    "progress": [
      "Profile complete"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "",
    "early": [],
    "threshold": "First referral from an unprofiled office or prescriber, or added to priority list",
    "feed": "HCP, Status · daily",
    "priority": "High",
    "caseType": "Account profile",
    "guardrails": [
      "Runs on an account case, not a patient case"
    ],
    "openItems": [
      "Does the FRM team profile new offices today? What is captured, and where?"
    ]
  },
  "rz-aw2": {
    "code": "AW2",
    "group": "account",
    "codes": [
      "PROFILE_DONE"
    ],
    "hub": "",
    "module": null,
    "progress": [
      "Education logged"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "",
    "early": [],
    "threshold": "Profile complete",
    "feed": "SCRAII event",
    "priority": "Medium",
    "caseType": "Account education",
    "guardrails": [],
    "openItems": [
      "Is there approved collateral for the in-service?"
    ]
  },
  "rz-aw3": {
    "code": "AW3",
    "group": "account",
    "codes": [
      "FIRST_N_ENROLLMENTS"
    ],
    "hub": "",
    "module": null,
    "progress": [
      "N clean submissions"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "",
    "early": [],
    "threshold": "First N patient enrollments at an office (N per brand)",
    "feed": "Status · daily",
    "priority": "Medium",
    "caseType": "Account new starts",
    "guardrails": [],
    "openItems": [
      "How many submissions before an office is self-sufficient (N)?"
    ]
  },
  "rz-aw4": {
    "code": "AW4",
    "group": "account",
    "codes": [
      "TIER_CADENCE",
      "STAFF_CHANGE"
    ],
    "hub": "",
    "module": null,
    "progress": [
      "Profile reconfirmed"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "",
    "early": [],
    "threshold": "Tier cadence (e.g., quarterly for priority) or a staff-change signal",
    "feed": "Schedule · SCRAII",
    "priority": "Low",
    "caseType": "Account touchpoint",
    "guardrails": [],
    "openItems": [
      "How often should a priority account be touched when nothing is wrong?"
    ]
  },
  "rz-aw5": {
    "code": "AW5",
    "group": "account",
    "codes": [
      "REPEAT_BLOCKERS"
    ],
    "hub": "",
    "module": null,
    "progress": [
      "Pattern clears"
    ],
    "exhausted": [],
    "onExhausted": "—",
    "cancelTo": "",
    "early": [],
    "threshold": "Repeated blockers at one office over a window",
    "feed": "SCRAII counters",
    "priority": "Medium",
    "caseType": "Account pattern",
    "guardrails": [],
    "openItems": [
      "Who handles payer-level patterns and clinical escalations?"
    ]
  },
  "rz-module": {
    "code": "MOD",
    "group": "shared",
    "codes": [],
    "hub": "",
    "module": {
      "wait": 2,
      "escalate": true,
      "every": 0,
      "optional": false,
      "attempts": [
        {
          "day": "1",
          "tpl": "Script 1 from the calling trigger",
          "channel": "Email or call",
          "hub": "",
          "ask": ""
        },
        {
          "day": "3",
          "tpl": "Script 2 from the calling trigger",
          "channel": "Email or call",
          "hub": "",
          "ask": ""
        },
        {
          "day": "5",
          "tpl": "Script 3 (call brief)",
          "channel": "Call or visit",
          "hub": "",
          "ask": ""
        }
      ]
    },
    "progress": [
      "Exit codes passed in by the trigger"
    ],
    "exhausted": [],
    "onExhausted": "Escalate to FRM leadership; stays visible on the case",
    "cancelTo": "G",
    "early": [],
    "threshold": "Called by MI, UC, B, C, D, E, F, H",
    "feed": "SCRAII · shared sub-workflow",
    "priority": "High",
    "caseType": "—",
    "guardrails": [
      "Steps here are shared by every trigger that calls the module"
    ],
    "openItems": []
  }
};

export const RZ_TEMPLATES = [
  {
    "id": "TPL-0510",
    "name": "Missing info · Day 1 intro and ask",
    "kind": "Email",
    "audience": "HCP office",
    "status": "APPROVED",
    "subject": "Missing information · [Office name] · [Case ID]",
    "body": "Dear Dr [Prescriber last name] and team,\n\nThe hub has flagged missing information on case [Case ID] since [Status date]: [Status reason].\n\nPlease send the outstanding item to [SP name] so enrollment can continue. I am happy to help by phone.\n\nThank you,\n[FRM name]\n[FRM phone]"
  },
  {
    "id": "TPL-0511",
    "name": "Missing info · Day 3 follow-up",
    "kind": "Email",
    "audience": "HCP office",
    "status": "APPROVED",
    "subject": "Follow-up · [Office name] · [Case ID]",
    "body": "Dear Dr [Prescriber last name] and team,\n\nFollowing up on case [Case ID]. The item below is still outstanding after [Days in status] days:\n[Status reason]\n\nYou have [Other open cases at office] other open cases with us. I can walk through them together on one call.\n\n[FRM name]"
  },
  {
    "id": "TPL-0515",
    "name": "Missing info · Day 5 call talking points",
    "kind": "Call brief",
    "audience": "HCP office",
    "status": "APPROVED",
    "subject": "Day 5 call · [Office name] · [Case ID]",
    "body": "• How many attempts have been made, and by whom\n• The risk: the case may close after the final attempt\n• Ask: is there a better number or a caregiver? When is the next visit? Can the office call the patient directly?"
  },
  {
    "id": "TPL-A",
    "name": "A — day 1, intro and ask",
    "kind": "Email",
    "subject": "Jupiterol patient support — [Office name], ref [Case ID]",
    "body": "Hi [Office contact],\n\nI'm [FRM name], the Field Reimbursement Manager supporting MyRock Assist for your office. [Hub/SP name] is trying to reach [Chased party] to complete enrollment. Could you ask the patient to call [Hub/SP name] at [phone], or save that number so the call comes through? Please send any requested information directly to [Hub/SP name]; I've copied [SP contact] here.\n\nThank you,\n[FRM name] · [phone]"
  },
  {
    "id": "TPL-B",
    "name": "B — day 3, follow-up",
    "kind": "Email",
    "subject": "Following up — ref [Case ID]",
    "body": "Hi [Office contact], following up on my note from [date]. [Hub/SP name] still hasn't been able to reach [Chased party] to move this forward. Is there a better number, or a caregiver we should contact? If it's easier, the patient can call [Hub/SP name] at [phone]."
  },
  {
    "id": "BRIEF-D5",
    "name": "Day 5 call brief",
    "kind": "Call brief",
    "subject": "",
    "body": "• How many attempts have been made, and by whom\n• The risk: the case may close after the final attempt\n• Ask: is there a better number or a caregiver? When is the next visit? Can the office call the patient directly?"
  },
  {
    "id": "TPL-INTRO",
    "name": "Intro — new enrollment or prescriber",
    "kind": "Email",
    "subject": "Jupiterol support for [Office name]",
    "body": "Hi [Office contact],\n\nI'm [FRM name], the Field Reimbursement Manager for Jupiterol in your area. I support offices with access questions alongside MyRock Assist.\n\nMyRock Assist: [MyRock Assist website]\nEnrollment form: attached\nMy direct line: [phone]\n\nThank you,\n[FRM name]"
  },
  {
    "id": "SCR-STATUS",
    "name": "Status check (stalled case)",
    "kind": "Email",
    "subject": "Checking in — ref [Case ID]",
    "body": "Hi [Office contact], the case for [Patient ref] has been [Status in plain words] for [Days in status] days. Is there anything the office is waiting on, or anything I can help unblock with [Hub/SP name]?"
  },
  {
    "id": "TPL-PA",
    "name": "PA reminder",
    "kind": "Email",
    "subject": "PA form reminder — ref [Case ID]",
    "body": "Hi [Office contact], [Hub/SP name] sent the prior authorization form for [Patient ref]. It hasn't been submitted to the payer yet. Could the office complete and submit it, or let me know if something is missing? I've copied [SP contact]."
  },
  {
    "id": "TPL-APPEAL",
    "name": "Appeal support",
    "kind": "Email",
    "subject": "Appeal support — ref [Case ID]",
    "body": "Hi [Office contact], the PA for [Patient ref] was denied ([Denial reason]). I can help with what the appeal should include. [Hub/SP name] will send the payer's letter; please send the appeal to [Hub/SP name] at [phone]."
  },
  {
    "id": "TPL-SHIP",
    "name": "Ask office to have patient call SP",
    "kind": "Email",
    "subject": "Ready to ship — ref [Case ID]",
    "body": "Hi [Office contact], coverage is approved for [Patient ref], but [Hub/SP name] hasn't been able to schedule shipment. Could you ask the patient to call [Hub/SP name] at [phone]?"
  },
  {
    "id": "TPL-REFILL",
    "name": "Refill check",
    "kind": "Email",
    "subject": "Refill check — ref [Case ID]",
    "body": "Hi [Office contact], [Hub/SP name] hasn't recorded a refill for [Patient ref]. Is the patient still on therapy, or has the plan changed? The patient can reach [Hub/SP name] at [phone]."
  },
  {
    "id": "TPL-COVER",
    "name": "Coverage progress (bridge / QS)",
    "kind": "Email",
    "subject": "Coverage update — ref [Case ID]",
    "body": "Hi [Office contact], [Patient ref] has [Days left] days left on the bridge program. [Hub/SP name] is working coverage. Is there anything the office still needs to send?"
  },
  {
    "id": "PROMPT-DEBRIEF",
    "name": "Debrief prompt",
    "kind": "FRM prompt",
    "subject": "",
    "body": "• What did the office say?\n• Could anything have been done earlier?\n• Reason group (pre-filled from the code): Choice · Coverage · Contact · Transfer"
  },
  {
    "id": "TPL-AW1",
    "name": "Account intro (AW1)",
    "kind": "Email",
    "subject": "Introduction — Jupiterol access support for [Office name]",
    "body": "Hi [Office contact],\n\nI'm [FRM name], the Jupiterol Field Reimbursement Manager for your area. I'd like 20 minutes to learn how your office handles enrollment and prior authorization so I can make access smoother for your patients.\n\n[FRM name] · [phone]"
  },
  {
    "id": "TPL-AW2",
    "name": "Access education packet (AW2)",
    "kind": "Email",
    "subject": "Jupiterol access resources for [Office name]",
    "body": "Hi [Office contact], as promised, here is the Jupiterol access overview: MyRock Assist hub, the SP network, copay support, PAP, Bridge and Quick Start, plus payer coverage criteria and documentation requirements. Approved collateral is attached."
  }
];

export const RZ_MODULE_STEPS = [
  {
    "n": 1,
    "step": "Build the brief: patient ID or name (per PHI consent), status in plain words, days in status, SP/hub contact, other open cases at this office",
    "actor": "System",
    "where": "Scraii",
    "type": "Auto",
    "cfg": "Fields shown"
  },
  {
    "n": 2,
    "step": "Batch check: is there already an open outreach to this office within the window? If so, add this case to it",
    "actor": "System",
    "where": "Scraii",
    "type": "Auto",
    "cfg": "Window"
  },
  {
    "n": 3,
    "step": "Draft the email from the trigger's template for this attempt; cc the SP/hub contact",
    "actor": "System",
    "where": "Scraii",
    "type": "Template · AI optional",
    "cfg": "Template per attempt"
  },
  {
    "n": 4,
    "step": "FRM picks a channel: send the draft, or call using the brief",
    "actor": "FRM",
    "where": "Email / phone / visit",
    "type": "Manual",
    "cfg": "—"
  },
  {
    "n": 5,
    "step": "FRM confirms the outreach (one click: channel, contact reached Y/N, note)",
    "actor": "FRM",
    "where": "Scraii",
    "type": "Manual confirmation",
    "cfg": "—"
  },
  {
    "n": 6,
    "step": "Wait for a milestone status, or time out after N days",
    "actor": "System",
    "where": "Scraii",
    "type": "Auto (wait-for-event)",
    "cfg": "Milestone codes, N days"
  },
  {
    "n": 7,
    "step": "Milestone reached → close with reason",
    "actor": "System",
    "where": "Scraii",
    "type": "Auto",
    "cfg": "Exit codes"
  },
  {
    "n": 8,
    "step": "No milestone and attempts remain → next attempt with the next script",
    "actor": "System",
    "where": "Scraii",
    "type": "Auto",
    "cfg": "Max attempts, script order"
  },
  {
    "n": 9,
    "step": "Max attempts reached → escalate to FRM leadership; stays visible on the FRM's case",
    "actor": "System",
    "where": "Scraii",
    "type": "Auto",
    "cfg": "Escalation role"
  }
];

export const RZ_CHANNELS = [
  "Email or call",
  "Email or phone",
  "Call or visit",
  "Follow-up",
  "Optional email or phone"
];

/** Six-check gate chain shown on gated communication steps. */
export const GATES = [
  "Consent",
  "Contact frequency",
  "Time of day",
  "Content approval",
  "Reachability",
  "Channel registration",
];

export const RZ_META = {
  "rz-mi": {
    "threshold": "On receipt (next 8 AM feed)",
    "feed": "Status · daily 8 AM ET",
    "priority": "High",
    "caseType": "Missing info",
    "guardrails": [
      "Missing items always go to the hub or SP, never to the FRM",
      "Name the patient only when PATIENT_PHI_CONSENT_FLAG = Y; otherwise use the case ID",
      "No PHI in email subject lines or push notifications"
    ],
    "openItems": [
      "We know that information is missing and the attempt number, not what is missing. Ask AssistRx for the missing-item list."
    ]
  },
  "rz-uc": {
    "threshold": "On receipt (next 8 AM feed)",
    "feed": "Status · daily 8 AM ET",
    "priority": "High",
    "caseType": "Unable to contact",
    "guardrails": [
      "Name the patient only when PATIENT_PHI_CONSENT_FLAG = Y",
      "No PHI in email subject lines or push notifications"
    ],
    "openItems": []
  },
  "rz-a": {
    "threshold": "On receipt",
    "feed": "Status, Patient View, HCP · daily",
    "priority": "Medium",
    "caseType": "New start",
    "guardrails": [
      "Need a \"first seen\" date per NPI to detect a new prescriber"
    ],
    "openItems": [
      "HCP extract needs a first-seen date per NPI"
    ]
  },
  "rz-b": {
    "threshold": "Older than the stage threshold",
    "feed": "Patient View · daily",
    "priority": "Medium",
    "caseType": "Stalled case",
    "guardrails": [
      "A new attempt number alone does not count as progress"
    ],
    "openItems": [
      "PA / appeal threshold waits on the turnaround benchmark"
    ]
  },
  "rz-c": {
    "threshold": "No PH12 after 5 business days",
    "feed": "Status · daily",
    "priority": "High",
    "caseType": "PA not submitted",
    "guardrails": [
      "cc the SP contact on the reminder"
    ],
    "openItems": []
  },
  "rz-d": {
    "threshold": "On receipt",
    "feed": "Status · daily",
    "priority": "High",
    "caseType": "Appeal",
    "guardrails": [
      "Follow-ups on day 4, day 10, then every 14 days while PH21 / PH22 / PS17 is open"
    ],
    "openItems": [
      "SP denials (PS16) carry no reason; get it from the SP"
    ]
  },
  "rz-e": {
    "threshold": "No PS34 or AS01 after 4 days",
    "feed": "Status · daily",
    "priority": "Medium",
    "caseType": "Approved not shipped",
    "guardrails": [
      "Use status codes, not fill dates, for this trigger"
    ],
    "openItems": []
  },
  "rz-f": {
    "threshold": "Last fill + days supply + 10 days, no new dispense",
    "feed": "Dispense · weekly Tuesday",
    "priority": "Medium",
    "caseType": "Refill overdue",
    "guardrails": [
      "Dispense data arrives weekly on Tuesday; this trigger can lag up to a week"
    ],
    "openItems": [
      "Ask SPs for daily dispense, or accept the weekly lag"
    ]
  },
  "rz-g": {
    "threshold": "On receipt",
    "feed": "Status · daily",
    "priority": "Low",
    "caseType": "Debrief",
    "guardrails": [
      "Replaces Jeanne's weekly manual search by latest status"
    ],
    "openItems": []
  },
  "rz-h": {
    "threshold": "Program max − N days, no commercial first fill",
    "feed": "Patient View · daily",
    "priority": "Low",
    "caseType": "Bridge near max",
    "guardrails": [
      "Outreach is optional"
    ],
    "openItems": [
      "Program max duration and lead time come from Sanofi; not in the data dictionary"
    ]
  },
  "rz-aw1": {
    "threshold": "First referral from an unprofiled office or prescriber, or added to priority list",
    "feed": "HCP, Status · daily",
    "priority": "High",
    "caseType": "Account profile",
    "guardrails": [
      "Runs on an account case, not a patient case"
    ],
    "openItems": [
      "Does the FRM team profile new offices today? What is captured, and where?"
    ]
  },
  "rz-aw2": {
    "threshold": "Profile complete",
    "feed": "SCRAII event",
    "priority": "Medium",
    "caseType": "Account education",
    "guardrails": [],
    "openItems": [
      "Is there approved collateral for the in-service?"
    ]
  },
  "rz-aw3": {
    "threshold": "First N patient enrollments at an office (N per brand)",
    "feed": "Status · daily",
    "priority": "Medium",
    "caseType": "Account new starts",
    "guardrails": [],
    "openItems": [
      "How many submissions before an office is self-sufficient (N)?"
    ]
  },
  "rz-aw4": {
    "threshold": "Tier cadence (e.g., quarterly for priority) or a staff-change signal",
    "feed": "Schedule · SCRAII",
    "priority": "Low",
    "caseType": "Account touchpoint",
    "guardrails": [],
    "openItems": [
      "How often should a priority account be touched when nothing is wrong?"
    ]
  },
  "rz-aw5": {
    "threshold": "Repeated blockers at one office over a window",
    "feed": "SCRAII counters",
    "priority": "Medium",
    "caseType": "Account pattern",
    "guardrails": [],
    "openItems": [
      "Who handles payer-level patterns and clinical escalations?"
    ]
  },
  "rz-module": {
    "threshold": "Called by MI, UC, B, C, D, E, F, H",
    "feed": "SCRAII · shared sub-workflow",
    "priority": "High",
    "caseType": "—",
    "guardrails": [
      "Steps here are shared by every trigger that calls the module"
    ],
    "openItems": []
  }
};

export const RZ_SIGNALS = [
  {
    "label": "Missing info (hub / SP)",
    "codes": [
      "PH02.7",
      "PH02.8",
      "PH02.9",
      "PH03.1",
      "PH03.2",
      "PH03.3",
      "PS02",
      "PS11",
      "PS25"
    ]
  },
  {
    "label": "Unable to contact",
    "codes": [
      "PS29",
      "APS29",
      "PS30",
      "APS30"
    ]
  },
  {
    "label": "Prior authorization",
    "codes": [
      "PS08",
      "PH11",
      "PH12",
      "PS13",
      "PH13",
      "PS16",
      "PH14",
      "PH16",
      "PH170",
      "PH171",
      "PH172",
      "PH173"
    ]
  },
  {
    "label": "Appeal",
    "codes": [
      "PS17",
      "PS23",
      "PS24",
      "PH21",
      "PH22",
      "PH23",
      "PH180",
      "PH187"
    ]
  },
  {
    "label": "Shipping and fills",
    "codes": [
      "PS27",
      "PS34",
      "AS01"
    ]
  },
  {
    "label": "Discontinued / cancelled",
    "codes": [
      "CS*",
      "DS*",
      "CS07",
      "CS10",
      "DS07",
      "DS10",
      "CS15"
    ]
  },
  {
    "label": "Holds (no alert)",
    "codes": [
      "APS35",
      "APS67",
      "APS68",
      "APS42"
    ]
  },
  {
    "label": "Data fields",
    "codes": [
      "NEW_PATIENT_START = Y",
      "NEW_NPI",
      "FACILITY_ID",
      "PRIORITY_LIST",
      "LAST_STATUS_DATE",
      "HUB_LAST_STATUS_DATE",
      "COM_SP_LAST_STATUS_DATE",
      "COM_SP_LAST_FILL_DATE",
      "COM_SP_LAST_FILL_DAYS_SUP",
      "QS_APPROVED_DT",
      "BRIDGE_REF_START_DATE"
    ]
  },
  {
    "label": "SCRAII events and counters",
    "codes": [
      "PROFILE_DONE",
      "FIRST_N_ENROLLMENTS",
      "TIER_CADENCE",
      "STAFF_CHANGE",
      "REPEAT_BLOCKERS"
    ]
  }
];

export const RZ_COND = {
  "status": [
    "On receipt (next 8 AM feed)"
  ],
  "absence": [
    "No PH12 after 5 business days",
    "No PS34 or AS01 after 4 days",
    "Last fill + days supply + 10 days, no new dispense"
  ],
  "threshold": [
    "Older than the stage threshold",
    "Program max − N days, no commercial first fill",
    "Repeated blockers at one office over a window"
  ],
  "event": [
    "On receipt",
    "First referral from an unprofiled office or prescriber",
    "Profile complete",
    "First N patient enrollments at an office"
  ],
  "schedule": [
    "Tier cadence (e.g., quarterly for priority) or a staff-change signal"
  ],
  "module": [
    "Called by another workflow"
  ],
  "manual": [
    "Started by a user"
  ]
};

export const RZ_FEEDS = [
  "Status · daily 8 AM ET",
  "Patient View · daily",
  "HCP · daily",
  "Dispense · weekly Tuesday",
  "SCRAII event",
  "Schedule · SCRAII",
  "SCRAII counters"
];

export const RZ_FEED_FOR = {
  "status": "Status · daily 8 AM ET",
  "absence": "Status · daily 8 AM ET",
  "threshold": "Patient View · daily",
  "event": "SCRAII event",
  "schedule": "Schedule · SCRAII",
  "module": "SCRAII event",
  "manual": "SCRAII event"
};

export const RZ_TRIG_HINT = {
  "status": "Fires when a status code arrives in the feed.",
  "absence": "Fires when an expected status does not arrive in time.",
  "threshold": "Fires when a date or counter passes a limit.",
  "event": "Fires on a data event, such as a new enrollment or a new prescriber.",
  "schedule": "Fires on a calendar cadence.",
  "module": "Runs only when another workflow calls it.",
  "manual": "Started by a user from the case."
};

